module.exports = "/fonts/fa-regular-400.woff?0e6b58ac5d805dfcd66f61e447b7ddd6";